var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#f4cc8e",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 13.2,
    x2: 50,
    y2: 2.8,
    stroke: "#e53935",
    strokeWidth: 2.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.92,
    y1: 10.18,
    x2: 59.21,
    y2: 3.71,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.54,
    y1: 12.49,
    x2: 68.06,
    y2: 6.39,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.56,
    y1: 16.24,
    x2: 76.22,
    y2: 10.75,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.71,
    y1: 21.29,
    x2: 83.38,
    y2: 16.62,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.76,
    y1: 27.44,
    x2: 89.25,
    y2: 23.78,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.51,
    y1: 34.46,
    x2: 93.61,
    y2: 31.94,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.82,
    y1: 42.08,
    x2: 96.29,
    y2: 40.79,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.8,
    y1: 50,
    x2: 97.2,
    y2: 50,
    strokeWidth: 2.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.82,
    y1: 57.92,
    x2: 96.29,
    y2: 59.21,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.51,
    y1: 65.54,
    x2: 93.61,
    y2: 68.06,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.76,
    y1: 72.56,
    x2: 89.25,
    y2: 76.22,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.71,
    y1: 78.71,
    x2: 83.38,
    y2: 83.38,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.56,
    y1: 83.76,
    x2: 76.22,
    y2: 89.25,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.54,
    y1: 87.51,
    x2: 68.06,
    y2: 93.61,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.92,
    y1: 89.82,
    x2: 59.21,
    y2: 96.29,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 86.8,
    x2: 50,
    y2: 97.2,
    strokeWidth: 2.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.08,
    y1: 89.82,
    x2: 40.79,
    y2: 96.29,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.46,
    y1: 87.51,
    x2: 31.94,
    y2: 93.61,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.44,
    y1: 83.76,
    x2: 23.78,
    y2: 89.25,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.29,
    y1: 78.71,
    x2: 16.62,
    y2: 83.38,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.24,
    y1: 72.56,
    x2: 10.75,
    y2: 76.22,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.49,
    y1: 65.54,
    x2: 6.39,
    y2: 68.06,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.18,
    y1: 57.92,
    x2: 3.71,
    y2: 59.21,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.2,
    y1: 50,
    x2: 2.8,
    y2: 50,
    strokeWidth: 2.35
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.18,
    y1: 42.08,
    x2: 3.71,
    y2: 40.79,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.49,
    y1: 34.46,
    x2: 6.39,
    y2: 31.94,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.24,
    y1: 27.44,
    x2: 10.75,
    y2: 23.78,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.29,
    y1: 21.29,
    x2: 16.62,
    y2: 16.62,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27.44,
    y1: 16.24,
    x2: 23.78,
    y2: 10.75,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.46,
    y1: 12.49,
    x2: 31.94,
    y2: 6.39,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.08,
    y1: 10.18,
    x2: 40.79,
    y2: 3.71,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 39,
    x2: 50,
    y2: 61,
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39,
    y1: 50,
    x2: 61,
    y2: 50,
    strokeWidth: 1.05
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 31,
    fill: "#e53935"
  }, "N"), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 77,
    fill: "#f4cc8e"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    x: 76.5,
    y: 54,
    fill: "#f4cc8e"
  }, "E"), /*#__PURE__*/React.createElement("text", {
    x: 23.5,
    y: 54,
    fill: "#f4cc8e"
  }, "W"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.4ba0c4b91f3648f5179c71d3aca9630c.svg";
export { ForwardRef as ReactComponent };